import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import PaymentForm from './PaymentForm';

const Payment = ({ clientSecret, publishableKey, redirectUrl }) => {
  // Load Stripe with the branch-specific publishable key
  const stripePromise = useMemo(
    () => loadStripe(publishableKey),
    [publishableKey]
  );

  return (
    <Elements
      stripe={stripePromise}
      options={{
        appearance: { theme: 'flat' },
        clientSecret
      }}
    >
      <PaymentForm redirectUrl={redirectUrl} />
    </Elements>
  );
};

Payment.propTypes = {
  clientSecret: PropTypes.string.isRequired,
  publishableKey: PropTypes.string.isRequired,
  redirectUrl: PropTypes.string.isRequired
};

export default Payment;
